import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchAndPickV2Component } from './components/search-and-pick/search-and-pick.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { PipesModule } from '@nx-fe/pipes';
import { SelectModule } from '@soti/select';
import { MatMenuModule } from '@angular/material/menu';
import { PopupModule } from '@soti/popup';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatOptionDisplayWrapperPipe } from './sa-matoptiondisplaywrapper.pipe';
import { UserBadgeComponent } from '../reports/components/user-badge/user-badge.component';
import { EllipsisComponent } from '../reports/components/ellipsis/ellipsis.component';
import { TooltipModule } from '@soti/tooltip';
@NgModule({
  declarations: [SearchAndPickV2Component, MatOptionDisplayWrapperPipe, UserBadgeComponent, EllipsisComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    PipesModule,
    SelectModule,
    MatMenuModule,
    PopupModule,
    MatSelectModule,
    MatOptionModule,
    TooltipModule,
  ],
  exports: [SearchAndPickV2Component],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SearchAndPickModule {}
